import { EItemGroup } from '@services/ecommerceService';

import { OUT_OF_STOCK } from '../constants';

export const isProductAvailable = ({ stockAvailability }: { stockAvailability: string }) =>
  stockAvailability !== OUT_OF_STOCK;

export const getProductGroup = ({ freeProduct, upselling }: { freeProduct: boolean; upselling: boolean }) => {
  if (upselling) {
    return EItemGroup.UPSELLING;
  }

  if (freeProduct) {
    return EItemGroup.GIFT;
  }

  return EItemGroup.PRODUCT;
};
